import { translations } from "./lib/english/english.translations";

export type CcfTranslatorProviderType = typeof translations;
export type CcfTranslationKey = keyof typeof translations.text;
export type CcfTranslations = typeof translations.text;
